export var PlaceSort;
(function (PlaceSort) {
    PlaceSort["ADMINISTRATIVE_CODE"] = "administrative_code";
    PlaceSort["ID"] = "id";
    PlaceSort["NAME"] = "name";
    PlaceSort["WEIGHT"] = "weight";
})(PlaceSort || (PlaceSort = {}));
